export const globalApiPrefix = 'api';
